import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { JOB_API } from "./apiRoutes";

const mutateAddNewsMedia = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${JOB_API}/`, data);
};

const useAddNewsMediaMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddNewsMedia,
    ...queryParams,
  });

export default useAddNewsMediaMutation;
